import { generateApiUrl, request } from '@/utils/ajax';
import { OrderSearchOptions } from './orders';

export interface ExportColumnDefinition {
    key: string;
    name: string;
    isMandatory: boolean;
    isDefault: boolean;
}

export interface SimpleOrderExportOptions {
    columns: string[];
}

export interface RoomFormExportOptions {
    columns: string[];
}

export interface RoomFormByUnitExportOptions {
    includeFloorPlan: boolean;
    columns: string[];
}

export interface InvoiceExportOptions {
    columns: string[];
}

export function getSimpleOrderExportColumns(): Promise<ExportColumnDefinition[]> {
    return request(`api/order/export/simple/columns`, {
        method: 'GET',
        json: true,
    }).then((x) => x.json());
}

export function getRoomFormOrderExportColumns(): Promise<ExportColumnDefinition[]> {
    return request(`api/order/export/room-form/columns`, {
        method: 'GET',
        json: true,
    }).then((x) => x.json());
}

export function getRoomFormByUnitOrderExportColumns(): Promise<ExportColumnDefinition[]> {
    return request(`api/order/export/room-form/by-unit/columns`, {
        method: 'GET',
        json: true,
    }).then((x) => x.json());
}

export function getInvoiceExportColumns(): Promise<ExportColumnDefinition[]> {
    return request(`api/order/export/invoice/columns`, {
        method: 'GET',
        json: true,
    }).then((x) => x.json());
}

export function getOrderSimpleExportUrl(filter: OrderSearchOptions, options: SimpleOrderExportOptions) {
    return generateApiUrl(`/api/order/export/simple`, { ...filter, columns: options?.columns?.join(',') });
}

export function getOrderRoomFormExportUrl(filter: OrderSearchOptions, options: RoomFormExportOptions) {
    return generateApiUrl(`/api/order/export/room-form`, { ...filter, columns: options?.columns?.join(',') });
}

export function getOrderRoomFormByUnitExportUrl(filter: OrderSearchOptions, options: RoomFormByUnitExportOptions) {
    return generateApiUrl(`/api/order/export/room-form/by-unit`, { ...filter, ...options });
}

export function getInvoiceExportUrl(filter: OrderSearchOptions, options: InvoiceExportOptions | null) {
    return generateApiUrl(`/api/order/export/invoice`, { ...filter, columns: options?.columns?.join(',') });
}

export function getCostsBreakdownExportUrl(filter: OrderSearchOptions, options: InvoiceExportOptions | null) {
    return generateApiUrl(`/api/order/export/costs`, { ...filter, columns: options?.columns?.join(',') });
}

export function getUniziteOrderExport(options: OrderSearchOptions) {
    return generateApiUrl(`/api/order/export/unizite`, options);
}
